// src/utils/datetime.js
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Normalise n'importe quelle valeur date en objet dayjs UTC valide.
 * Accepte : string ISO, Date, objet dayjs, timestamp number
 */
function _toDayjs(d) {
  if (!d) return null;
  // Déjà un objet dayjs
  if (d && typeof d === "object" && typeof d.isValid === "function") {
    return d.isValid() ? d : null;
  }
  // String ISO — forcer la lecture en UTC si pas de timezone
  if (typeof d === "string") {
    const hastz = /[Zz]$/.test(d) || /[+\-]\d{2}:\d{2}$/.test(d);
    return dayjs(hastz ? d : d + "Z").utc();
  }
  // Date native ou timestamp number
  return dayjs(d);
}

/**
 * Envoie en UTC ISO 8601 avec Z → "2026-03-22T10:45:00.000Z"
 * Accepte un objet dayjs, Date, ou string ISO.
 */
export const toUtcIso = (d) => {
  const dj = _toDayjs(d);
  if (!dj) return null;
  return dj.utc().toISOString();
};

/**
 * Affiche une date en heure locale du navigateur (Africa/Porto-Novo UTC+1).
 * "2026-03-22T10:45:00Z" → "22/03/2026 11:45"
 */
export const fmtLocal = (d) => {
  if (!d) return "—";
  const dj = _toDayjs(d);
  if (!dj || !dj.isValid()) return "—";
  const date = dj.toDate();
  return date.toLocaleString("fr-FR", {
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", hour12: false,
  });
};

/**
 * Valeur pour <input type="datetime-local"> en heure locale.
 * Accepte objet dayjs, string ISO, Date.
 * "2026-03-22T10:45:00Z" + UTC+1 → "2026-03-22T11:45"
 */
export const fmtLocalInput = (d) => {
  if (!d) return "";
  const dj = _toDayjs(d);
  if (!dj || !dj.isValid()) return "";
  // .local() convertit de UTC vers l'heure locale du navigateur
  return dj.local().format("YYYY-MM-DDTHH:mm");
};

export default { toUtcIso, fmtLocal, fmtLocalInput };